/* Midnight Prophet — slow fade-and-rise on scroll-in.
   Adds .mp-in to any .mp-reveal element as it enters the viewport. */
(function () {
  function reveal() {
    var nodes = document.querySelectorAll('.mp-reveal:not(.mp-in)');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('mp-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mp-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    nodes.forEach(function (n) { io.observe(n); });
  }

  if (document.readyState !== 'loading') {
    reveal();
  } else {
    document.addEventListener('DOMContentLoaded', reveal);
  }

  // Re-scan when sections are added/edited in the theme editor.
  document.addEventListener('shopify:section:load', reveal);
})();

/* Homepage choreography — transparent header that darkens as the hero
   wordmark approaches, gentle hero drift, and a scroll cue. */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  var group = document.getElementById('header-group');
  var inner = document.querySelector('.mp-hero__inner');
  var cue = document.querySelector('.mp-hero__scroll');
  if (!group && !inner) return;

  function word() { return document.querySelector('.mp-hero__wordmark'); }
  var raf = null;

  function update() {
    raf = null;
    var y = window.scrollY || window.pageYOffset || 0;
    var vh = window.innerHeight || 800;

    // Header: transparent at the top. The black bar holds until the hero's
    // centered text is reached (~half a viewport down); the logo wordmark
    // fades in earlier, on its own pace.
    if (group) {
      // Black bar + hairline — hold until the hero text, then fade to ground.
      var barHold = vh * 0.06;   // start darkening almost immediately on scroll
      var barDist = vh * 0.26;   // then fade over ~a quarter of a viewport
      var barProg = (y - barHold) / barDist;
      barProg = barProg < 0 ? 0 : (barProg > 1 ? 1 : barProg);
      barProg = barProg * barProg * (3 - 2 * barProg); // smoothstep easing
      // --mp-hdr drives the black layer (::before)
      group.style.setProperty('--mp-hdr', barProg.toFixed(3));
      group.style.boxShadow = '0 1px 0 rgba(184, 151, 90, ' + (barProg * 0.4).toFixed(3) + ')';

      // Logo wordmark — begins almost immediately for an earlier reveal.
      var hw = group.querySelector('.header-logo__wordmark');
      if (hw) {
        var wordHold = 120;
        var wordDist = vh * 0.5;
        var wordProg = (y - wordHold) / wordDist;
        wordProg = wordProg < 0 ? 0 : (wordProg > 1 ? 1 : wordProg);
        wordProg = wordProg * wordProg * (3 - 2 * wordProg);
        hw.style.opacity = wordProg.toFixed(3);
      }
    }

    // Hero inner: gentle drift up + fade as you scroll into it
    if (inner) {
      var p = y / (vh * 0.7);
      if (p > 1) p = 1;
      inner.style.opacity = (1 - p * 0.85).toFixed(3);
      inner.style.transform = 'translateY(' + (-p * 42).toFixed(1) + 'px) scale(' + (1 - p * 0.05).toFixed(3) + ')';
    }

    // Scroll cue fades the moment you move
    if (cue) cue.style.opacity = y > 30 ? '0' : '';
  }

  function onScroll() { if (raf === null) raf = window.requestAnimationFrame(update); }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', update);
})();
